import _toConsumableArray from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
import { mapState, mapMutations } from 'vuex';
import { frameInRoutes } from '@/router/routes';
import layoutHeaderAside from '@/layout/header-aside';
export default {
  data: function data() {
    return {
      title: '',
      setting: [{
        title: '追加页面 1',
        name: 'add-routes-1',
        path: 'add-routes/1',
        component: '1'
      }, {
        title: '追加页面 2',
        name: 'add-routes-2',
        path: 'add-routes/2',
        component: '2'
      }, {
        title: '追加页面 3',
        name: 'add-routes-3',
        path: 'add-routes/3',
        component: '3'
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('d2admin/menu', ['header'])), {}, {
    dataView: function dataView() {
      return JSON.stringify(this.setting, null, 2);
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations({
    pageInit: 'd2admin/page/init',
    headerSet: 'd2admin/menu/headerSet'
  })), {}, {
    onClick: function onClick(_ref) {
      var title = _ref.title,
          name = _ref.name,
          path = _ref.path,
          _component = _ref.component;
      // vue router 的设计暂时不能支持在路由示例上访问动态添加的路由
      // 目前可行的解决方法是自行维护一个存储路由数据的位置
      // https://github.com/vuejs/vue-router/issues/1234
      // https://github.com/vuejs/vue-router/issues/1859
      // https://github.com/vuejs/vue-router/issues/1955
      // https://github.com/vuejs/vue-router/issues/2454
      // https://github.com/vuejs/vue-router/issues/2280
      // 所以暂时先不做对路由已经存在的判断
      var route = [{
        path: '/demo/playground',
        component: layoutHeaderAside,
        children: [{
          path: path,
          name: name,
          component: function component() {
            return import('@/views/demo/playground/add-routes/alternates/' + _component + '.vue');
          },
          meta: {
            title: title
          }
        }]
      }];
      this.$router.addRoutes(route); // 更新标签页池

      this.pageInit([].concat(_toConsumableArray(frameInRoutes), route)); // 演示更新菜单

      var menuGroup = {
        title: '临时菜单',
        icon: 'plus-square',
        children: []
      };
      var menu = {
        path: "/demo/playground/".concat(path),
        title: title,
        icon: 'file-o'
      };
      var header = cloneDeep(this.header);
      var menuGroupIndex = header.findIndex(function (e) {
        return e.title === menuGroup.title;
      }); // 如果顶栏菜单已经有这个组，就在组里添加项目，反之新建一个菜单组

      if (menuGroupIndex >= 0) {
        header[menuGroupIndex].children.push(menu);
      } else {
        menuGroup.children.push(menu);
        header.push(menuGroup);
      }

      this.headerSet(header); // 跳转

      this.$router.push({
        name: name
      });
    }
  })
};